export default "__VITE_ASSET__B5H910S4__"